import { observer } from 'mobx-react';
import { BlankIcon } from '../SectionTypeSelector/Icons';
import { T } from '../../../../../../../Translations';

interface Props {
  onOpen: () => void;
}

function NoExperiences({ onOpen }: Props) {
  return (
    <div
      className="text-center py-16 text-muted-foreground cursor-pointer min-h-[280px] flex flex-col items-center justify-center gap-4"
      onClick={onOpen}
      data-intercom-target="builder-v2-no-experiences-cta"
    >
      <p>
        <T kind='No courses added yet. Click "Add courses" to begin.' />
      </p>
      <div className="w-16 h-16 flex items-center justify-center">
        <BlankIcon />
      </div>
    </div>
  );
}

export default observer(NoExperiences);
